import { RequestDelivery } from '@ravago/shared/page-data/models/elements';

import { useMutation } from '@tanstack/react-query';

import { requestDelivery } from '../call-off-order.utils';

export const useRequestDeliveryMutation = () =>
  useMutation({
    mutationFn: (request: RequestDelivery) => requestDelivery(request)
  });
